/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FileModel { 
    id: number;
    createDate: string;
    fileName: string;
    mimeType: string;
    size?: number;
    guid: string;
    fileHash?: string;
    folder?: string;
    temporary: boolean;
}

